import { Component, h, Prop, Host } from '@stencil/core';
import DOMPurify from 'dompurify';

/**
 * @internal
 */
@Component({
  tag: 'bahf-sanitizer',
  scoped: true
})
export class BahfSanitizer {
  @Prop() content: string = '';

  private get sanitizedHtml(): string {
    if (!this.content) return '';
    return DOMPurify.sanitize(this.content, { ALLOWED_TAGS: ['strong'] });
  }

  render() {
    return <Host innerHTML={this.sanitizedHtml}></Host>;
  }
}
